// import GD from "../views/RestAPI/getData";
export const getIpAddress = async () => {
  // https://extreme-ip-lookup.com/json/
  try {
    let data = {};
    // await GD.GetCallAPI('https://geolocation-db.com/json/').then((resp) => {
    //   data = {
    //     city: "",
    //     country: '',
    //     query: "",
    //     region: "",
    //     continent: '',
    //   };
    // });

    data = {
      city: '',
      country: '',
      query: '',
      region: '',
      continent: '',
    };
    return data;
  } catch (error) {
    // console.log('error', error);
  }
};



// WEBPACK FOOTER //
// ./src/common/getIpAddress.js